<script setup lang="ts">
import Tag from '~/components/ui/tag/Tag.vue';

import DoorOpenIcon from '~icons/material-symbols-light/door-open-sharp';
import LocationIcon from '~icons/material-symbols-light/location-on-outline';
import WhatsappIcon from '~icons/pilar/whatsapp';

import contactFormLocale from './ContactFormModal.locale.json';

defineProps<{ schedule: string; location: string }>();
</script>

<template>
	<div
		class="flex flex-col items-start gap-5 border border-white-dark-3 p-[15px]"
		data-testid="open-house-visit-summary"
	>
		<Tag
			class="h-6 gap-1 rounded-none bg-tertiary px-2 py-0 xl:py-0"
			text-class="text-white"
		>
			<template #icon>
				<DoorOpenIcon class="size-4 text-[#e3e3e3]" aria-hidden="true" />
			</template>
			Open House
		</Tag>
		<div class="flex w-full flex-col gap-4">
			<p class="text-sm font-medium leading-5 md:text-base md:leading-[26px]">
				{{ schedule }}
			</p>
			<div class="flex flex-col gap-2">
				<p
					v-if="location"
					class="flex items-start gap-2 text-sm leading-[normal] md:items-center md:gap-3 md:leading-normal"
				>
					<LocationIcon
						class="size-5 shrink-0 text-primary-light-3 md:size-6"
						aria-hidden="true"
					/>
					{{ location }}
				</p>
				<p
					class="flex items-start gap-2 text-sm leading-normal text-primary-light-1 md:items-center md:gap-3"
				>
					<WhatsappIcon
						class="size-5 shrink-0 text-primary-light-3 md:size-6 [&_path]:fill-current"
						aria-hidden="true"
					/>
					<span class="md:hidden">{{
						contactFormLocale.pt.openHouse.mobileAddressMessage
					}}</span>
					<span class="hidden md:inline">{{
						contactFormLocale.pt.openHouse.addressMessage
					}}</span>
				</p>
			</div>
		</div>
	</div>
</template>
